import { Eye, EyeSlash, Plus, Trash } from '@phosphor-icons/react'
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import { v4 as uuidv4 } from 'uuid'
import { TitleLine } from '../../../../components/TitleLine'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import { Select } from '../../../../components/common/Select'
import { ContextResidents } from '../../../../context/context_residents'
import api from '../../../../services/api'

import {
  AddButtonContainer,
  AddressContainer,
  ButtonContainer,
  Container,
  Divider,
  RemoveButtonContainer,
  Row,
  Section,
  Title,
} from './styles'
import axios from 'axios'

interface AddressProps {
  id: string
  id_responsible_base: string
  address: string
  state: string
  city: string
  burgh: string
  zipcode: string
  latitude: number
  longitude: number
}
interface VehiclesProps {
  id: string
  vehicle: string
  color: string
  plate: string
  type: string
}

type UserInfoProps = {
  id_base: string
  name: string
  email: string
  phone: string
  birthdate: string
}

type ContractProps = {
  id: string
}

type ResidentsProps = {
  id: string
  login: string
  password: string
  role: string
  // active: boolean
  UserInfo: UserInfoProps
  Address: AddressProps[]
  Vehicle: VehiclesProps[]
  Contract: ContractProps
}

interface FormNewResidentProps {
  handleModal: Dispatch<SetStateAction<boolean>>
}

export const FormNewResident = ({ handleModal }: FormNewResidentProps) => {
  const { createItem } = useContext(ContextResidents)

  const [baseList, setBaseList] = useState([])
  const [contractList, setContractList] = useState([])

  useEffect(() => {
    api
      .get('/v1/dashboard/base/list')
      .then((res) => {
        setBaseList(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])
  useEffect(() => {
    api
      .get('/v1/contract/list')
      .then((res) => {
        setContractList(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const baseOptions = baseList?.map((item) => {
    const id = item.id
    const value = item.base

    return { id, value }
  })
  const contractOptions = contractList?.map((item) => {
    const id = item.id
    const value = item.name

    return { id, value }
  })

  const states = [
    { id: 'AC', value: 'Acre' },
    { id: 'AL', value: 'Alagoas' },
    { id: 'AP', value: 'Amapá' },
    { id: 'AM', value: 'Amazonas' },
    { id: 'BA', value: 'Bahia' },
    { id: 'CE', value: 'Ceará' },
    { id: 'DF', value: 'Distrito Federal' },
    { id: 'ES', value: 'Espírito Santo' },
    { id: 'GO', value: 'Goiás' },
    { id: 'MA', value: 'Maranhão' },
    { id: 'MT', value: 'Mato Grosso' },
    { id: 'MS', value: 'Mato Grosso do Sul' },
    { id: 'MG', value: 'Minas Gerais' },
    { id: 'PA', value: 'Pará' },
    { id: 'PB', value: 'Paraíba' },
    { id: 'PR', value: 'Paraná' },
    { id: 'PE', value: 'Pernambuco' },
    { id: 'PI', value: 'Piauí' },
    { id: 'RJ', value: 'Rio de Janeiro' },
    { id: 'RN', value: 'Rio Grande do Norte' },
    { id: 'RS', value: 'Rio Grande do Sul' },
    { id: 'RO', value: 'Rondônia' },
    { id: 'RR', value: 'Roraima' },
    { id: 'SC', value: 'Santa Catarina' },
    { id: 'SP', value: 'São Paulo' },
    { id: 'SE', value: 'Sergipe' },
    { id: 'TO', value: 'Tocantins' },
  ]

  const [addressList, setAddressList] = useState<AddressProps[]>([
    {
      id: uuidv4(),
      id_responsible_base: '',
      address: '',
      state: '',
      city: '',
      burgh: '',
      zipcode: '',
      latitude: 0,
      longitude: 0,
    },
  ])

  const [vehiclesList, setVehiclesList] = useState<VehiclesProps[]>([])

  const [newItem, setNewItem] = useState<ResidentsProps>({
    id: uuidv4(),
    login: '',
    password: '',
    role: 'MORADOR_ADM',
    UserInfo: {
      id_base: '',
      name: '',
      email: '',
      phone: '',
      birthdate: '',
    },
    Address: [
      {
        id: uuidv4(),
        id_responsible_base: '',
        address: '',
        state: '',
        city: '',
        burgh: '',
        zipcode: '',
        latitude: 0,
        longitude: 0,
      },
    ],
    Vehicle: [],
    Contract: {
      id: '',
    },
  })

  const [isPasswordShowing, setIsPasswordShowing] = useState(false)
  // const [password, setPassword] = useState('')

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleAddAddress = () => {
    const newAddress = {
      id: uuidv4(),
      id_responsible_base: '',
      address: '',
      state: '',
      city: '',
      burgh: '',
      zipcode: '',
      latitude: 0,
      longitude: 0,
    }
    setAddressList((current) => [...current, newAddress])
  }

  const handleAddVehicles = () => {
    const newVehicle = {
      id: uuidv4(),
      vehicle: '',
      type: '',
      plate: '',
      color: '',
    }
    setVehiclesList((current) => [...current, newVehicle])
  }

  const handleRemoveAddress = (idx) => {
    const item = addressList.at(idx)
    setAddressList(addressList.filter((address) => address.id !== item.id))
    setAddressList((updatedList) => {
      setNewItem((prev) => ({
        ...prev,
        Address: updatedList,
      }))
      return updatedList
    })
  }

  const handleRemoveVehicles = (idx) => {
    const item = vehiclesList.at(idx)
    setVehiclesList(vehiclesList.filter((vehicle) => vehicle.id !== item.id))
    setVehiclesList((updatedList) => {
      setNewItem((prev) => ({
        ...prev,
        Vehicle: updatedList,
      }))
      return updatedList
    })
  }

  const handleCepChange = (index) => async (e) => {
    try {
      const newArray = addressList.map((item, i) => {
        if (index === i) {
          return { ...item, [e.target.name]: e.target.value }
        } else {
          return item
        }
      })

      const cep = newArray[index].zipcode

      let response
      if (cep.length >= 8) {
        response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
      }

      // address: response.data.logradouro,
      // zipcode: response.data.cep,
      // burgh: response.data.bairro,
      // city: response.data.localidade,
      // state: response.data.uf,

      setAddressList(newArray)
      setAddressList((updatedList) => {
        if (response) {
          updatedList[index].address = response.data.logradouro
          updatedList[index].zipcode = response.data.cep
          updatedList[index].burgh = response.data.bairro
          updatedList[index].city = response.data.localidade
          updatedList[index].state = response.data.uf
        }

        setNewItem((prev) => ({
          ...prev,
          UserInfo: {
            ...prev.UserInfo,
            id_base: updatedList[index].id_responsible_base,
          },
          Address: updatedList,
        }))
        console.log(newItem)
        return updatedList
      })
    } catch (error) {
      console.error('Erro na requisição:', error.message)
    }
  }

  const handleAddressChange = (index) => (e) => {
    const newArray = addressList.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value }
      } else {
        return item
      }
    })
    setAddressList(newArray)
    setAddressList((updatedList) => {
      setNewItem((prev) => ({
        ...prev,
        UserInfo: {
          ...prev.UserInfo,
          id_base: updatedList[0].id_responsible_base,
        },
        Address: updatedList,
      }))
      console.log(newItem)
      return updatedList
    })
  }

  const handleVehicleChange = (index) => (e) => {
    const newArray = vehiclesList.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value }
      } else {
        return item
      }
    })
    setVehiclesList(newArray)
    setNewItem((prev) => ({
      ...prev,
      Vehicle: vehiclesList,
    }))
  }

  const handleInputChange = (field, value) => {
    setNewItem((prevItem) => ({
      ...prevItem,
      [field]: value,
    }))
  }

  const handleUserInfoChange = (field, value) => {
    setNewItem((prevItem) => ({
      ...prevItem,
      UserInfo: {
        ...prevItem.UserInfo,
        [field]: value,
      },
    }))
  }

  const handleContractChange = (value) => {
    setNewItem((prevItem) => ({
      ...prevItem,
      Contract: {
        id: value,
      },
    }))
  }

  const setUpdateItem = () => {
    // console.log(newItem, 'adoliajdlaksjdlaksdjlaks')
    setNewItem((prev) => ({
      ...prev,
      Address: addressList,
    }))
    setNewItem((prev) => ({
      ...prev,
      Vehicle: vehiclesList,
    }))
    createItem(newItem)
    // toggleFunction(handleModalSave)
  }

  const [passwordStrong, setPasswordStrong] = useState(false)
  const [passwordError, setPasswordError] = useState('')

  const checkPasswordStrength = (password) => {
    if (password.length < 8) {
      setPasswordError(`A senha deve ter pelo menos ${8} caracteres.`)
      setPasswordStrong(false)
      return false
    }

    const hasUpperCase = /[A-Z]/.test(password)
    const hasLowerCase = /[a-z]/.test(password)
    const hasNumber = /\d/.test(password)
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)

    if (!hasUpperCase) {
      setPasswordError('A senha deve conter pelo menos uma letra maiúscula.')
      setPasswordStrong(false)
      return false
    } else if (!hasLowerCase) {
      setPasswordError('A senha deve conter pelo menos uma letra minúscula.')
      setPasswordStrong(false)
      return false
    } else if (!hasNumber) {
      setPasswordError('A senha deve conter pelo menos um número.')
      setPasswordStrong(false)
      return false
    } else if (!hasSpecialChar) {
      setPasswordError('A senha deve conter pelo menos um símbolo especial.')
      setPasswordStrong(false)
      return false
    }
    setPasswordError('')
    setPasswordStrong(true)
    return true
  }

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value

    handleInputChange('password', e.target.value)

    checkPasswordStrength(newPassword)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    console.log(newItem)
    // setNewItem((prev) => ({
    //   ...prev,
    //   UserInfo: {
    //     ...prev.UserInfo,
    //     id_base: addressList[0].id_responsible_base,
    //   },
    // }))
    if (passwordStrong) {
      setUpdateItem()
      toggleFunction(handleModal)
    }
  }

  return (
    <Container onSubmit={handleSubmit}>
      <Section>
        <TitleLine title="Dados do titular" />
        <Input.Root>
          <Input.Label title="Nome do usuário" htmlFor="newResidentName" />
          <Input.Wrapper>
            <Input.Content
              id="newResidentName"
              type="text"
              value={newItem.UserInfo.name}
              onChange={(e) => handleUserInfoChange('name', e.target.value)}
              required
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="E-mail" htmlFor="newResidentEmail" />
          <Input.Wrapper>
            <Input.Content
              id="newResidentEmail"
              type="text"
              value={newItem.UserInfo.email}
              onChange={(e) => handleUserInfoChange('email', e.target.value)}
              required
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="Telefone" htmlFor="newResidentPhone" />
          <Input.Wrapper>
            <Input.Content
              id="newResidentPhone"
              type="tel"
              mask="telNumber"
              maxLength={13}
              value={newItem.UserInfo.phone}
              onChange={(e) => handleUserInfoChange('phone', e.target.value)}
              required
            />
          </Input.Wrapper>
        </Input.Root>
      </Section>
      <Divider />
      <Section>
        <Title>Dados de residência</Title>
        <Select
          onchange={(e) => handleContractChange(e.target.value)}
          currentOption={newItem.Contract.id}
          label={{
            title: 'Contrato de seguro',
            htmlFor: '',
            color: '',
            fontSize: '12px',
          }}
          data={contractOptions}
          backgroundcolor=""
          bordercolor="#CECECE"
          outlinecolor=""
        />
        {/* <Input.Root>
          <Input.Label
            title="Base responsável"
            htmlFor="newResidentResponsableBase"
          />
          <Input.Wrapper>
            <Input.Content
              id="newResidentResponsibleBase"
              type="text"
              value={newItem.base}
              onChange={(e) => handleInputChange('base', e.target.value)}
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label
            title="Posto responsável"
            htmlFor="newResidentResponsiblePost"
          />
          <Input.Wrapper>
            <Input.Content
              id="newResidentResponsiblePost"
              type="text"
              value={newItem.outpost}
              onChange={(e) => handleInputChange('outpost', e.target.value)}
            />
          </Input.Wrapper>
        </Input.Root> */}
        {addressList?.map((item, idx) => {
          return (
            <AddressContainer key={'Address' + idx}>
              <TitleLine title={'Endereço ' + (idx + 1)} />
              <Input.Root flex="1">
                <Input.Label title="CEP" htmlFor="newResidentCEP" />
                <Input.Wrapper>
                  <Input.Content
                    id="newResidentCEP"
                    type="text"
                    value={item.zipcode}
                    name="zipcode"
                    mask="cep"
                    required
                    onChange={handleCepChange(idx)}
                  />
                </Input.Wrapper>
              </Input.Root>

              <Row>
                <Input.Root flex="2">
                  <Input.Label title="Endereço" htmlFor="newResidentAddress" />
                  <Input.Wrapper>
                    <Input.Content
                      id="newResidentAddress"
                      type="text"
                      name="address"
                      value={item.address}
                      onChange={handleAddressChange(idx)}
                      required
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label title="Bairro" htmlFor="newResidentDistrict" />
                  <Input.Wrapper>
                    <Input.Content
                      id="newResidentDistrict"
                      type="text"
                      name="burgh"
                      value={item.burgh}
                      onChange={handleAddressChange(idx)}
                      required
                    />
                  </Input.Wrapper>
                </Input.Root>
              </Row>
              <Row>
                <Input.Root flex="2">
                  <Input.Label title="Cidade" htmlFor="newResidentCity" />
                  <Input.Wrapper>
                    <Input.Content
                      id="newResidentCity"
                      type="text"
                      name="city"
                      value={item.city}
                      onChange={handleAddressChange(idx)}
                      required
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Select
                  flex="1"
                  onchange={handleAddressChange(idx)}
                  name={'state'}
                  label={{
                    title: 'Estado',
                    htmlFor: '',
                    color: '',
                    fontSize: '12px',
                  }}
                  data={states}
                  backgroundcolor=""
                  bordercolor="#CECECE"
                  currentOption={item.state}
                  outlinecolor=""
                />
              </Row>
              <Select
                onchange={handleAddressChange(idx)}
                name={'id_responsible_base'}
                label={{
                  title: 'Base responsável',
                  htmlFor: '',
                  color: '',
                  fontSize: '12px',
                }}
                data={baseOptions || []}
                backgroundcolor=""
                bordercolor=""
                currentOption={item.id_responsible_base}
                outlinecolor=""
              />
              {/* <Input.Root>
                <Input.Label
                  title="Posto responsável"
                  htmlFor="newResidentResponsiblePost"
                />
                <Input.Wrapper>
                  <Input.Content
                    id="newResidentResponsiblePost"
                    type="text"
                    value={newItem.outpost}
                    onChange={(e) =>
                      handleInputChange('outpost', e.target.value)
                    }
                  />
                </Input.Wrapper>
              </Input.Root> */}
              {idx === 0 ? null : (
                <>
                  {/* <Select
                    onchange={handleAddressChange(idx)}
                    name={'id_responsible_base'}
                    label={{
                      title: 'Base responsável',
                      htmlFor: '',
                      color: '',
                      fontSize: '14px',
                    }}
                    data={baseOptions || []}
                    backgroundcolor=""
                    bordercolor=""
                    currentOption={item.id_responsible_base}
                    outlinecolor=""
                  /> */}
                  {/* <Input.Root>
                    <Input.Label
                      title="Base responsável"
                      htmlFor="newResidentResponsableBase"
                    />
                    <Input.Wrapper>
                      <Input.Content
                        id="newResidentResponsibleBase"
                        name="base"
                        type="text"
                        onChange={handleAddressChange(idx)}
                        required
                      />
                    </Input.Wrapper>
                  </Input.Root> */}
                  {/* <Input.Root>
                    <Input.Label
                      title="Posto responsável"
                      htmlFor="newResidentResponsiblePost"
                    />
                    <Input.Wrapper>
                      <Input.Content
                        id="newResidentResponsiblePost"
                        type="text"
                        name="outpost"
                        onChange={handleAddressChange(idx)}
                        required
                      />
                    </Input.Wrapper>
                  </Input.Root> */}
                  <RemoveButtonContainer>
                    <Button.Root
                      backgroundColor="#770A00"
                      type="button"
                      onClick={() => handleRemoveAddress(idx)}
                    >
                      <Button.Content title="Remover endereço" />
                      <Button.Icon>
                        <Trash size={15} fill="white" />
                      </Button.Icon>
                    </Button.Root>
                  </RemoveButtonContainer>
                </>
              )}
            </AddressContainer>
          )
        })}
        <AddButtonContainer>
          <Button.Root
            backgroundColor="#003E5F"
            type="button"
            onClick={handleAddAddress}
          >
            <Button.Content title="Adicionar outro endereço" />
            <Button.Icon>
              <Plus size={15} fill="white" />
            </Button.Icon>
          </Button.Root>
        </AddButtonContainer>
      </Section>
      <Divider />
      <Section>
        <Title>Veículos da residência</Title>
        {vehiclesList?.map((item, idx) => {
          return (
            <AddressContainer key={'Vehicle' + idx}>
              <TitleLine title={'Veículo ' + (idx + 1)} />
              <Select
                flex="1"
                onchange={handleVehicleChange(idx)}
                name={'type'}
                label={{
                  title: 'Tipo do veículo',
                  htmlFor: '',
                  color: '',
                  fontSize: '12px',
                }}
                data={[
                  { id: 'CARRO', value: 'Carro' },
                  { id: 'MOTO', value: 'Moto' },
                ]}
                backgroundcolor=""
                bordercolor="#CECECE"
                currentOption={item.type}
                outlinecolor=""
              />
              <Row>
                <Input.Root flex="1">
                  <Input.Label
                    title="Veículo do usuário:"
                    htmlFor="newResidentVehicleUSer"
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id="newResidentVehicleUSer"
                      type="text"
                      value={item.vehicle}
                      name="vehicle"
                      onChange={handleVehicleChange(idx)}
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label
                    title="Cor do veículo:"
                    htmlFor="newResidentVehicleColor"
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id="newResidentVehicleColor"
                      type="text"
                      name="color"
                      value={item.color}
                      onChange={handleVehicleChange(idx)}
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label
                    title="Placa:"
                    htmlFor="newResidentVehiclePlate"
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id="newResidentVehiclePlate"
                      type="text"
                      name="plate"
                      value={item.plate}
                      onChange={handleVehicleChange(idx)}
                    />
                  </Input.Wrapper>
                </Input.Root>
              </Row>
              <RemoveButtonContainer>
                <Button.Root
                  backgroundColor="#770A00"
                  type="button"
                  onClick={() => handleRemoveVehicles(idx)}
                >
                  <Button.Content title="Remover veículo" />
                  <Button.Icon>
                    <Trash size={15} fill="white" />
                  </Button.Icon>
                </Button.Root>
              </RemoveButtonContainer>
            </AddressContainer>
          )
        })}
        <AddButtonContainer>
          <Button.Root
            backgroundColor="#003E5F"
            type="button"
            onClick={handleAddVehicles}
          >
            <Button.Content title="Adicionar outro veículo" />
            <Button.Icon>
              <Plus size={15} fill="white" />
            </Button.Icon>
          </Button.Root>
        </AddButtonContainer>
      </Section>
      <Divider />
      <Section>
        <Title>Informações de acesso</Title>
        <Input.Root>
          <Input.Label title="Usuário - login" htmlFor="newResidentUserLogin" />
          <Input.Wrapper>
            <Input.Content
              id="newResidentUserLogin"
              type="text"
              value={newItem.login}
              onChange={(e) => handleInputChange('login', e.target.value)}
              required
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="Senha de acesso" htmlFor="newResidentPassword" />
          <Input.Wrapper>
            <Input.Content
              id="newResidentPassword"
              type={isPasswordShowing ? 'text' : 'password'}
              value={newItem.password}
              onChange={handlePasswordChange}
              required
            />
            <Input.Icon onClick={() => toggleFunction(setIsPasswordShowing)}>
              {isPasswordShowing ? (
                <Eye size={14} color="#494949" />
              ) : (
                <EyeSlash size={14} color="#494949" />
              )}
            </Input.Icon>
          </Input.Wrapper>
          {!passwordStrong && (
            <div style={{ color: 'red' }}>{passwordError}</div>
          )}
        </Input.Root>
        <ButtonContainer>
          <Button.Root backgroundColor="#308EC6" type="submit">
            <Button.Content title="Cadastrar" />
          </Button.Root>
        </ButtonContainer>
      </Section>
    </Container>
  )
}
